export default {
    title: 'Categories',
    subtitle: 'Categories list',
    createCategory: 'Create Category',
    createSubtitle: 'Add a new category to organize your resources',
    editCategory: 'Edit Category',
    editTitle: 'Edit Category',
    editSubtitle: 'Update category information',
    createSuccess: 'Category created successfully',
    createError: 'Failed to create category',
    updateSuccess: 'Category updated successfully',
    updateError: 'Failed to update category',
    loadError: 'Failed to load category',
    notFound: 'Category not found',
    images: 'Images',
    categoryForm: {
        name: 'Category Name',
        nameRequired: 'Category name is required',
        nameMinLength: 'Category name cannot be empty',
        namePlaceholder: 'Enter category name',
        description: 'Description',
        descriptionPlaceholder: 'Enter category description (optional)',
        color: 'Color',
        colorPattern: 'Color must be a valid hex color (e.g., #007bff)',
        preview: 'Preview'
    },
    categoryView: {
        loading: 'Loading category...',
        fetchError: 'Failed to load category',
        errorTitle: 'Error',
        notFound: 'Category not found',
        createdAt: 'Created',
        updatedAt: 'Updated',
        resourcesInCategory: 'Resources in this category',
        resourcesDescription: 'All resources in the {{categoryName}} category'
    },
    categoriesAdmin: {
        createTitle: 'Create Category',
        editTitle: 'Edit Category',
        deleteTitle: 'Delete Category',
        createSuccess: 'Category created successfully',
        updateSuccess: 'Category updated successfully',
        deleteSuccess: 'Category deleted successfully',
        createError: 'Failed to create category',
        updateError: 'Failed to update category',
        deleteError: 'Failed to delete category',
        deleteConfirmation: 'Are you sure you want to delete this category? This action cannot be undone.'
    }
};
